import PropTypes from "prop-types"
import React from "react"
import arrowRightIcon from "./arrow-right.svg"
import Image from "components/ui/Image"

function ContentCTA({
  image,
  title,
  children,
  "link-text": linkText,
  "link-url": linkUrl,
}) {
  return (
    <span className="my-9 flex flex-col overflow-hidden rounded-2xl border border-whisper-grey bg-cloud md:flex-row">
      {image && (
        <Image className="flex-shrink-0 object-cover md:w-40" src={image} />
      )}
      <span className="block px-5 py-5 md:pl-9 md:pr-8">
        {title && <span className="text-2xl font-bold">{title}</span>}
        {children && (
          <span className="mt-1 block text-base font-light leading-tight">
            {children}
          </span>
        )}
        {linkText && linkUrl && (
          <a
            className="group mt-1 inline-flex items-center text-base font-semibold text-cove hover:text-cove"
            href={linkUrl}
          >
            {linkText}
            <img
              className="mt-1 h-7 w-7 transition group-hover:translate-x-1"
              src={arrowRightIcon}
              alt="Arrow to right"
            />
          </a>
        )}
      </span>
    </span>
  )
}

ContentCTA.propTypes = {
  /** Image */
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  /** Title */
  title: PropTypes.string,
  /** Body */
  children: PropTypes.node,
}

export default ContentCTA
